<div
    class="select-section"
    *ngIf="
        userRole === USER_ROLE.SUPER_ADMIN ||
        userRole === USER_ROLE.ADMIN ||
        loggedInUserService.isSuperAdmin() ||
        loggedInUserService.isGeneralManager() ||
        loggedInUserService.IsUserRelatedQualityAssurance()
    "
>
    <mat-form-field appearance="standard" class="select-dropdown">
        <mat-icon matSuffix><span class="material-symbols-outlined"> expand_more </span></mat-icon>
        <mat-select [(value)]="defaultValue" (selectionChange)="selectSection($event)">
            <mat-option [value]="0"> {{ 'allSections' | translate }}</mat-option>
            <mat-option *ngFor="let option of list | async" [value]="option.value">
                {{ option.name }}
            </mat-option>
        </mat-select>
    </mat-form-field>
</div>
